import React from 'react';
import { ELEMENTS } from '../utils/constants';

function OnboardingScreen({ stepIndex, tempUtopia, setTempUtopia, setRoute, completeOnboarding }) {
  const el = ELEMENTS[stepIndex];
  
  const saveUtopiaField = (key, value) => { 
    setTempUtopia((t) => ({ ...t, [key]: value })); 
  };

  return (
    <div className="p-4 h-full flex flex-col">
      <h2 className="text-2xl font-bold mb-2 dark:text-dark-text">Your {el.label} Utopia</h2>
      <p className="text-sm text-gray-600 dark:text-dark-textSecondary mb-4">Describe what your ideal {el.hint} feels like.</p>
      
      <div className="mb-4 p-3 rounded-lg bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800">
        <div className="text-sm text-blue-800 dark:text-blue-200">
          <strong>{el.label}:</strong> {el.hint}
        </div>
      </div>
      
      <textarea
        autoFocus
        value={tempUtopia[el.key]}
        onChange={(e) => saveUtopiaField(el.key, e.target.value)}
        className="flex-1 rounded-md border dark:border-dark-border p-3 text-sm bg-white dark:bg-dark-bg text-gray-900 dark:text-dark-text"
        placeholder={`I imagine my ${el.label.toLowerCase()}...`}></textarea>
      <div className="flex gap-2 mt-3">
        {stepIndex > 0 && (
          <button type="button" onClick={() => setRoute(`onboard-${stepIndex}`)} className="flex-1 py-2 rounded-md border dark:border-dark-border dark:bg-dark-surface dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-surfaceHover">Back</button>
        )}
        <button 
          type="button"
          onClick={(e) => {
            e.preventDefault();
            completeOnboarding();
          }} 
          className="py-2 px-4 rounded-md border border-gray-300 dark:border-dark-border text-gray-600 dark:text-dark-textSecondary hover:bg-gray-50 dark:hover:bg-dark-surfaceHover"
        >
          Skip for now
        </button>
        {stepIndex < ELEMENTS.length - 1 ? (
          <button type="button" onClick={() => setRoute(`onboard-${stepIndex + 2}`)} className="py-2 px-4 rounded-md bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 dark:hover:bg-blue-600">Next</button>
        ) : (
          <button type="button" onClick={completeOnboarding} className="py-2 px-4 rounded-md bg-green-600 dark:bg-green-500 text-white hover:bg-green-700 dark:hover:bg-green-600">Finish</button>
        )}
      </div>
    </div>
  );
}

export default OnboardingScreen;
